// GX Design System Colors — sourced from Figma (node 2615:16750)

export const GX_SUCCESS = '#00E676';
export const GX_FAILURE = '#FF1744';
export const GX_HIGHLIGHT = '#E84E0F';
export const GX_HIGHLIGHT_LIGHT = '#FF7043';
export const GX_MAIN_BACKGROUND = '#070818';
export const GX_TILE_DARK = '#0D1228';
export const GX_TILE_LIGHT = '#121836';
export const GX_ADDITIONAL_PAPER = '#12163F';
export const GX_TEXT = '#F8F8F8';
export const GX_TEXT_SECONDARY = '#A1A6AB';
export const GX_TEXT_DISABLED = '#6C737A';
export const GX_NEUTRAL = '#4F5458';
export const GX_RESPONSE = '#1A224D';
export const GX_SELECTION = '#31475A';
export const GX_FORWARD_HIGHLIGHT = '#10035D';
export const GX_SPOT_HIGHLIGHT = '#1F0808';
export const GX_MINI_TABLE_HIGHLIGHT = '#282F48';
export const GX_SUBTEXT = '#B0B0B0';
export const GX_CURVE_SELECTOR = '#1F295C';
export const GX_WARNING = '#CCAC00';
export const GX_FAILURE_LIGHT = '#FF4D6D';
export const GX_FAILURE_DARK = '#CC1236';
export const GX_INFO_MAIN = '#778899';

export const CHARTS_BLUE = '#00BFFF';
export const CHARTS_YELLOW = '#FFD700';
export const CHARTS_GREEN = '#2E8B57';
export const CHARTS_PURPLE = '#6363DF';
export const CHARTS_ORANGE = '#F3733F';
